import { Container } from 'react-bootstrap';
import "./MainHeroHeader.css"

const MainHeroHeader = () => {
  return(
    <div id="main-hero-header">
      <Container id="hero-header-main-text">
        <div id="hero-header-main-text-wrapper">
          <div id="hero-header-main-text-box">
            <span>
              Welcome to the American Causal Inference Conference 2022 Data Challenge
            </span>
          </div>
        </div>
        <div id="hero-header-sub-text">
          <span>Organized by Mathematica</span>
        </div>
      </Container>
    </div>
  );
}

export default MainHeroHeader;